import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { MoTravelDetailPage } from '@/features/moTravel/pages/MoTravelDetailPage';
import { moTravelDetailSearchSchema } from '@/features/moTravel/types/moTravel.types';

export const Route = createFileRoute('/_auth/geo-location/mo-travel-history/$userId')({
  parseParams: ({ userId }) => {
    const parsedId = Number(userId);
    if (!Number.isInteger(parsedId) || parsedId <= 0) throw notFound();
    return { userId: parsedId };
  },
  validateSearch: moTravelDetailSearchSchema,
  component: function MoTravelDetailRoute() {
    const { userId } = Route.useParams();
    return (
      <ErrorBoundary moduleName="MO Travel Details">
        <Suspense fallback={<PageLoader />}>
          <MoTravelDetailPage userId={userId} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
